import * as React from 'react'

const IconSplitView = (props) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.566 7.8v1.112l-9.563 9.562-.467.001a.5.5 0 0 1-.418-.226L20.566 7.8zm0 3.232v1.112l-6.33 6.33h-1.112l7.442-7.442zm0 3.225v1.119l-3.098 3.098-1.248.001a369.73 369.73 0 0 1 4.206-4.083l.14-.135zm0 3.24v.478a.5.5 0 0 1-.5.5l-.477-.001.977-.977zm-.5-11.972a.5.5 0 0 1 .423.232L10.036 16.208v-1.11l9.574-9.574.456.001zm-2.578-.001-7.452 7.452v-1.111l6.341-6.341h1.111zm-3.232 0-4.22 4.22V8.632l3.108-3.108h1.112zm-3.233 0-.987.988v-.487a.5.5 0 0 1 .5-.5l.487-.001zM3.4 5a.4.4 0 0 0-.4.4v13.2c0 .22.18.4.4.4h17.2a.4.4 0 0 0 .4-.4V5.4a.4.4 0 0 0-.4-.4H3.4zm0-.7h17.2a1.1 1.1 0 0 1 1.1 1.1v13.2a1.1 1.1 0 0 1-1.1 1.1H3.4a1.1 1.1 0 0 1-1.1-1.1V5.4a1.1 1.1 0 0 1 1.1-1.1zm.492 1.225h5.236c.194 0 .352.158.352.352v12.296a.352.352 0 0 1-.352.352H3.892a.352.352 0 0 1-.352-.352V5.877c0-.194.158-.352.352-.352z'
      fill='#FFF'
    />
  </svg>
)

export default IconSplitView
